import { useState } from "react"

//Styles
import myStyles from "../../../styles/assessments/AssessmentList.module.css"
import assessStyles from "../../../styles/assessments/Assessment.module.css"

//PrimeReact
import { Dialog } from "primereact/dialog"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { Calendar } from "primereact/calendar"

export default function AssessmentListFilters({
  filters,
  users,
  onSetFilters,
  onClose,
  createdByFieldName,
  updatedByFieldName,
}) {
  const [tempFilters, setTempFilters] = useState(filters)

  return (
    <Dialog
      header={"Filter"}
      visible={true}
      onHide={onClose}
      className={myStyles.filterDialog}
      closable={false}
    >
      <div className={myStyles.filterLayout}>
        <div className={myStyles.filterLayoutCreatedBy}>
          <label>Created by</label>
          <Dropdown
            value={tempFilters[createdByFieldName || "createdBy"]}
            options={users}
            optionValue="staff_id"
            optionLabel="staff_full_name"
            onChange={(e) => {
              let newFilters = { ...tempFilters }
              newFilters[createdByFieldName || "createdBy"] = e.value

              setTempFilters(newFilters)
            }}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterLayoutCreatedOn}>
          <label>Created on</label>
          <Calendar
            value={tempFilters.createdOn}
            onChange={(e) => {
              setTempFilters({ ...tempFilters, createdOn: e.value })
            }}
            placeholder="Select a date"
            className={`${myStyles.filterControl} ${myStyles.calendar}`}
          />
        </div>
        <div className={myStyles.filterLayoutUpdatedBy}>
          <label>Updated by</label>
          <Dropdown
            value={tempFilters[updatedByFieldName || "updatedBy"]}
            options={users}
            optionValue="staff_id"
            optionLabel="staff_full_name"
            s
            onChange={(e) => {
              let newFilters = { ...tempFilters }
              newFilters[updatedByFieldName || "updatedBy"] = e.value

              setTempFilters(newFilters)
            }}
            className={myStyles.filterControl}
          />
        </div>
        <div className={myStyles.filterLayoutUpdatedOn}>
          <label>Updated on</label>
          <Calendar
            value={tempFilters.updatedOn}
            placeholder="Select a date"
            className={`${myStyles.filterControl} ${myStyles.calendar}`}
            onChange={(e) => {
              setTempFilters({ ...tempFilters, updatedOn: e.value })
            }}
          />
        </div>
        <div className={myStyles.filterLayoutSearch}>
          <label>Search phrase</label>
          <span className={`p-input-icon-right ${myStyles.filterControl}`}>
            <i className="pi pi-search" />
            <InputText
              value={tempFilters.searchPhrase}
              onChange={(e) => {
                setTempFilters({ ...tempFilters, searchPhrase: e.target.value })
              }}
              placeholder="Keyword Search"
              className={myStyles.filterControl}
            />
          </span>
        </div>
        <div className={myStyles.filterLayoutClear}>
          <Button
            label="X  Reset all filters"
            className={assessStyles.actionButton}
            type="button"
            onClick={() => {
              onSetFilters({})
            }}
          />
        </div>
        <div className={myStyles.filterLayoutButtons}>
          <Button
            label="Cancel"
            className={assessStyles.button}
            type="button"
            onClick={() => {
              onClose()
            }}
          />
          <Button
            label={`Apply${
              Object.keys(tempFilters).length > 0
                ? ` [${Object.keys(tempFilters).length}]`
                : ""
            }`}
            className={assessStyles.button}
            type="button"
            onClick={() => {
              onSetFilters(tempFilters)
            }}
            disabled={Object.keys(tempFilters).length === 0}
          />
        </div>
      </div>
    </Dialog>
  )
}
